<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-col :span="24" :lg="12" :xl="14">
          <div class="box">
            <div class="header"><h3>个人信息</h3></div>

            <div class="formDiv">
              <el-form label-width="100px" :model="form" ref="formData">
                <el-form-item label="账 号 名" prop="loginName">
                  <el-input placeholder="" v-model="form.loginName" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="真实姓名" prop="userName">
                  <el-input placeholder="" v-model="form.userName"></el-input>
                </el-form-item>

                <el-form-item label="工作单位" prop="workUnit">
                  <el-input placeholder="" v-model="form.workUnit"></el-input>
                </el-form-item>

                <el-form-item label="联系电话" prop="telephone">
                  <el-input placeholder="" v-model="form.telephone"></el-input>
                </el-form-item>

                <el-form-item label="个人介绍" prop="synopsis">
                  <el-input type="textarea" placeholder="" v-model="form.synopsis" rows="6"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="update">更新</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>

        <el-col :span="24" :lg="12" :xl="10">
          <div class="box">
            <div class="header"><h3>手机绑定</h3></div>
            <div class="content">
              <div style="line-height: 40px">
                当前绑定的手机号：<span class="color-danger">{{ phone }}</span>
              </div>
              <div style="padding: 20px; border: 1px solid #e2e2e2; line-height: 180%; background-color: #f2f2f2; font-size: 12px">
                如果当前手机号{{ phone }}无法接受到短信，方才需要重新绑定新的手机号。 绑定手机号可享受以下服务：
                <ul>
                  <li>1. 找回密码服务</li>
                  <li>2. 修改密码服务</li>
                  <li>3. 业务流程进度提醒</li>
                </ul>
              </div>

              <el-row justify="center" align="center">
                <el-col :span="24" :lg="{ span: 24, offset: 0 }" :xl="{ span: 16, offset: 4 }">
                  <el-form label-width="100px" ref="formData2" :model="form2" style="margin: 30px 0 0 0">
                    <el-form-item label="登录密码" prop="password" :rules="ruleAccountPwd">
                      <el-input placeholder="" v-model="form2.password" :show-password="true"></el-input>
                    </el-form-item>

                    <el-form-item label="手机号码" prop="mobile" :rules="rulePhone">
                      <el-input placeholder="" v-model="form2.mobile"></el-input>
                    </el-form-item>

                    <el-form-item
                      label="图形验证码"
                      prop="captchaCode"
                      :rules="{
                        required: true,
                        min: 4,
                        max: 4,
                        message: '请填写4位数的图形验证码',
                        trigger: 'blur',
                      }"
                    >
                      <el-row>
                        <el-col :span="8">
                          <div>
                            <el-input ref="captchaCode" oninput="if(value.length>4)value=value.slice(0,4)" placeholder="图形验证码" v-model="form2.captchaCode"></el-input>
                          </div>
                        </el-col>

                        <el-col :span="9">
                          <el-image :src="'data:image/png;base64,' + captchaSrc" style="height: 40px" alt="单击刷新验证码" @click="loadCaptcha"></el-image>
                        </el-col>
                        <el-col :span="7">
                          <div style="padding-left: 10px">
                            <ButtonCountDown style="width: 100%" ref="ButtonCountDown" type="primary" text="发送短信" count="60" :method="sendSMS"></ButtonCountDown>
                          </div>
                        </el-col>
                      </el-row>
                    </el-form-item>

                    <el-form-item label="短信验证码" prop="smsCode" v-show="sendSMSed">
                      <el-row>
                        <el-col :span="8">
                          <div>
                            <el-input ref="smsCode" oninput="if(value.length>4)value=value.slice(0,4)" placeholder="短信验证码" v-model="form2.smsCode"></el-input>
                          </div>
                        </el-col>
                        <el-col :span="16">
                          <div style="margin-left: 15px">输入收到的4位数短信验证码</div>
                        </el-col>
                      </el-row>
                    </el-form-item>

                    <el-form-item>
                      <el-button type="primary" @click="submitBind" :disabled="!sendSMSed">确认绑定</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ dialogContent }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ButtonCountDown from "@/components/ButtonCountDown.vue"
import personApi from "@/api/person"
import accountApi from "@/api/account"
import captchaApi from "@/api/captcha"
import { validAccountPwd, validPhone } from "@/utils/valid"

export default {
  components: { PageHeader, ButtonCountDown },
  inject: ["reload"],
  data() {
    var validAccountPwdFun = (rule, value, callback) => {
      if (!validAccountPwd(value)) {
        callback(new Error("长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)"))
      } else {
        callback()
      }
    }
    var validPhoneFun = (rule, value, callback) => {
      if (!validPhone(value)) {
        callback(new Error("手机号码格式不正确"))
      } else {
        accountApi.checkMobileUnique(value).then((res) => {
          if (res.code == 0) {
            callback()
          } else if (res.code == 1) {
            callback("该手机号码已绑定")
          } else if (res.code == 301) {
            callback(new Error(res.data[0].msg))
          }
        })
      }
    }
    return {
      headLinks: [
        { path: "", title: "账号信息" },
        { path: "", title: "个人信息" },
      ],
      sendSMSed: false,
      dialogType: "",
      dialogVisible: false,
      dialogContent: "",
      captchaSrc: "",
      phone: "",
      form: {
        userName: "",
        telephone: "",
        synopsis: "",
        workUnit: "",
      },
      form2: {
        mobile: "",
        captchaCode: "",
        captchaCodeKey: "",
        smsCode: "",
        password: "",
      },
      ruleAccountPwd: [
        {
          required: true,
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)",
          trigger: "blur",
        },
        { validator: validAccountPwdFun, trigger: "blur" },
      ],
      rulePhone: [
        {
          required: true,
          trigger: "blur",
          message: "手机号码必须填写",
        },
        { validator: validPhoneFun, trigger: "blur" },
      ],
    }
  },

  mounted() {
    this.loadUserInfo()
  },

  created() {
    this.loadCaptcha()
  },

  methods: {
    dialogOpen(type, content) {
      this.dialogType = type
      this.dialogContent = content
      this.dialogVisible = true
    },
    dialogClose() {
      if (this.dialogType == "mobile") {
        this.$refs["mobile"].focus()
      } else if (this.dialogType == "captchaCode") {
        this.$refs["captchaCode"].focus()
      } else if (this.dialogType == "smsCode") {
        this.$refs["smsCode"].focus()
      }
      this.dialogType = null
      this.dialogVisible = false
    },
    loadUserInfo() {
      personApi.getInfo().then((res) => {
        if (res.code == 0) {
          this.form = res.data
          if (this.form.mobile!=null && this.form.mobile.length > 0) {
            this.phone = this.form.mobile.substring(0, 3) + "****" + this.form.mobile.substring(7, 11)
          }
        }
      })
    },
    loadCaptcha() {
      captchaApi.image("char").then((res) => {
        if (res.code == 0) {
          this.captchaSrc = res.data.img
          this.form2.captchaCodeKey = res.data.key
        }
      })
    },

    update() {
      personApi.update(this.form).then((res) => {
        if (res.code == 0) {
          let name = this.form.userName != "" ? this.form.userName : this.form.loginName
          this.$store.commit("user/SET_NAME", name)
          this.$notify({
            title: "成功",
            message: "更新成功",
            type: "success",
          })
        } else {
          this.$notify.error({
            title: "错误",
            message: "更新失败" + res.msg,
          })
        }
      })
    },

    sendSMS() {
      Promise.all(
        ["mobile", "captchaCode"].map((item) => {
          return new Promise((resolve) => {
            this.$refs.formData2.validateField(item, (error) => {
              resolve(error)
            })
          })
        })
      ).then((data) => {
        if (data.length <= 0 || (data[0] == "" && data[1] == "")) {
          this.$refs.ButtonCountDown.start()
          personApi.sendSmsForBindMobile(this.form2.mobile, this.form2.captchaCode, this.form2.captchaCodeKey).then((res) => {
            if (res.code == 0) {
              this.sendSMSed = true
              this.dialogOpen("smsCode", "短信验证码已经发送到手机上，请注意查看")
            } else {
              this.$refs.ButtonCountDown.stop()
              this.dialogOpen("", "发送短信失败," + res.code.mobile)
            }
          })
        }
      })
    },

    submitBind() {
      this.$refs.formData2.validate((valid) => {
        if (valid) {
          personApi.bindMobile(this.form2).then((res) => {
            if (res.code == 0) {
              this.phone = this.form2.mobile.substring(0, 3) + "****" + this.form2.mobile.substring(7, 11)
              this.$notify({
                title: "成功",
                message: "绑定成功",
                type: "success",
              })
            } else if (res.code == 1) {
              this.$notify.error({
                title: "错误",
                message: "绑定失败," + res.msg,
              })
            } else if (res.code == 301) {
              let html = ""
              for (let item in res.data) {
                html += "<li>" + item.msg + "</li>"
              }
              this.$notify.error({
                title: "错误",
                message: "绑定失败<ul>" + html + "</ul>",
              })
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  margin: 30px;
  border: 1px solid #e2e2e2;
  padding: 15px 25px;
  height: 100%;
  height: 535px;

  .header {
    line-height: 44px;
  }
}

.formDiv {
  margin: 20px;
}
</style>
